
export function serLoading(state, loading){
  state.loading = loading
}
export function setContacts(state, contacts) {
    state.contacts = contacts;
}
export function setDateRangeParam(state) {

    const fechaActual = new Date(); // Fecha actual

    // Restar un mes a la fecha actual para obtener el mes anterior
    const fechaMesAnterior = restarMesesAFecha(fechaActual, 1);

    // Obtener el primer día del mes anterior
    const primerDiaMesAnterior = new Date(fechaMesAnterior.getFullYear(), fechaMesAnterior.getMonth(), 1);

    // Obtener el último día del mes anterior
    const ultimoDiaMesAnterior = new Date(fechaMesAnterior.getFullYear(), fechaMesAnterior.getMonth() + 1, 0);


    state.params.date = [
        primerDiaMesAnterior,
        ultimoDiaMesAnterior,
    ];

}

export function restarMesesAFecha(fecha, cantidadMeses) {
    const fechaClonada = new Date(fecha);

    // Obtener el mes y año actuales
    const mesActual = fechaClonada.getMonth();
    const anioActual = fechaClonada.getFullYear();

    // Calcular el nuevo mes y año
    let nuevoMes = mesActual - cantidadMeses;
    let nuevoAnio = anioActual;

    // Manejar el cambio de año si el nuevo mes es menor a 0
    while (nuevoMes < 0) {
        nuevoMes += 12;
        nuevoAnio--;
    }

    // Establecer la nueva fecha con los meses restados
    fechaClonada.setMonth(nuevoMes);
    fechaClonada.setFullYear(nuevoAnio);

    return fechaClonada;
}



// WEBPACK FOOTER //
// ./src/modules/delete-documents/mutations.js